// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmailChangePage_container__O64wJ","card":"ConfirmEmailChangePage_card__JUiZh","title":"ConfirmEmailChangePage_title__YDSrr"};